
import React from "react";
import { cn } from "@/lib/utils";
import { Brain } from "lucide-react";
import { motion } from "framer-motion";

interface LoadingProps {
  className?: string;
  size?: "small" | "medium" | "large";
}

const Loading: React.FC<LoadingProps> = ({ className, size = "medium" }) => {
  const sizes = {
    small: "h-4 w-4",
    medium: "h-8 w-8",
    large: "h-16 w-16",
  };

  const containerSizes = {
    small: "p-2",
    medium: "p-4",
    large: "p-8",
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-background">
      <div className={cn("flex flex-col items-center justify-center gap-4", className)}>
        <motion.div 
          className={cn(
            "flex items-center justify-center rounded-full bg-gradient-to-br from-brain-purple/20 to-brain-teal/20",
            containerSizes[size]
          )}
          animate={{ 
            scale: [1, 1.1, 1],
            opacity: [0.7, 1, 0.7],
            rotate: [0, 10, -10, 0]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >
          <Brain className={cn("animate-pulse text-brain-purple", sizes[size])} />
        </motion.div>
        <motion.p 
          className={cn("text-center text-muted-foreground")}
          animate={{ 
            opacity: [0.5, 1, 0.5]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity
          }}
        >
          Loading...
        </motion.p>
      </div>
    </div>
  );
};

export default Loading;
